import { Injectable } from "@angular/core";
import { Subject } from 'rxjs';


@Injectable()
export class ErrorMessageService {

  private messageSource = new Subject<any>();
  $errorMessage = this.messageSource.asObservable();

  updateErrorMessage(errorMessage: { message: string, error: boolean, key: string }) {
    this.messageSource.next(errorMessage);
  }

}
